import { CpfCnpjMaskDirective } from './cpf-cnpj-mask.directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [ CpfCnpjMaskDirective ],
    imports: [ CommonModule ],
    exports: [ CpfCnpjMaskDirective ],
})
export class CpfCnpjDirectiveModule {

}
